import { SearchSectionItems } from '@app/entities/models/search/search-section-items.model';

export class SearchSectionCollection {
  page!: number;
  pageSize!: number;
  totalItems!: number;
  items!: SearchSectionItems[];
  totalPages!: number;
}
